import {BaseService} from "./BaseService";
import {MapSite} from "../entities/MapSite";
import { StateService } from "@uirouter/angularjs";

export class MapSiteService extends BaseService<MapSite> {
    static $inject = ['$http','$q','$state'];
    constructor($http: ng.IHttpService, $q: ng.IQService, $state: StateService) {
        super($http, $q, $state, MapSite);
    }
    protected getBaseUrl():string{
        return "mapsite";
    }
}
